import React, {useEffect, useState} from 'react';
import CLoading from "../CLoading";
import FacItemCmdTable from "../../pageComponents/table/FacItemCmdTable";
import TTable from "../../pageComponents/table/TTable";
import FiltroEse from "./FiltroEse";
import Thead from "../../pageComponents/table/THead";
import FacFnSort from "../../pageComponents/table/FacFnSort";
import ItemPDF from "./ItemPDF";
import ItemInfoCliente from "./ItemInfoCliente";
import Api from "../../servicios/api/Api";
import LibToast from "../../lib/LibToast";

const apiCliente = Api.getApiCliente();

const facFnSort = (label, isAsc) => {
  
  if (label === "ID" || label === 'Fecha') {
    return FacFnSort.scalar("id", isAsc);
  } else if (label === "Evaluado") {
    return FacFnSort.scalar("evaluado", isAsc);
  } else if (label === "Monto") { //<--- pendiente
    return FacFnSort.scalar("monto", isAsc);
  }
}

function getTrDesktop(r, index, openPDF) {
  return <tr key={r.uid}>
    <td className="tdindex">{index + 1}</td>
    <td>
      <h4>{r.evaluado}</h4>
    </td>
    <td>
      <p>{r.email}</p>
      <p>{r.tel}</p>
      <div className="mt-5 has-text-grey" title="Tipo de Estudio">
        Tipo: {r.nombreTipoEse?.toUpperCase()}
      </div>
    </td>
    <td>
      <h4>{r.puesto}</h4>
    </td>
    <td title="Fecha de Solicitud">
      {r.fsol}
    </td>
    <td>
      <ItemPDF ese={r} openPDF={openPDF}/>
    </td>
    <td>
      <ItemInfoCliente ese={r}/>
    </td>
  
  </tr>;
}

function getTrMobile(r, index, openPDF) {
  return <tr key={r.uid}>
    <td>
      <h4>
        <span className="roundIndex">{index+1}</span>
        {r.evaluado}
      </h4>
      <p>{r.email}</p>
      <p>{r.tel}</p>
      <div className="mt-5 has-text-grey" title="Tipo de Estudio">
        Tipo: {r.nombreTipoEse?.toUpperCase()}
      </div>
      <h4><span style={{fontWeight:"lighter"}}>Puesto: </span> {r.puesto}</h4>
    </td>
    <td>
      <p title="Fecha de Solicitud">{r.fsol}</p>
      <ItemPDF ese={r} openPDF={openPDF}/>
      <ItemInfoCliente ese={r}/>
    
    </td>
  </tr>;
}

const isMobile = window.innerWidth < 720;

const EseTable = ({list}) => {
  
  const [filteredList, setFilteredList] = useState([])
  const [filtro, setFiltro] = useState({texto: ''});
  const [sortSel, setSortSel] = useState({});
  
  useEffect(() => {
    setFiltro({texto: ''})
  }, [list]);
  
  useEffect(() => {
    if (!list) {
      return;
    }
    
    const t = filtro.texto.toLowerCase();
    
    const listNew = list.filter(k => {
      const text = JSON.stringify(k).toLowerCase();
      return text.includes(t);
    });
    setFilteredList(listNew)
  }, [filtro])
  
  useEffect(() => {
    
    if (!sortSel.label) {
      return;
    }
    
    const {label, isAsc} = sortSel;
    
    const fn = facFnSort(label, isAsc);
    
    const listaItemsNew = [...filteredList].sort(fn);
    setFilteredList(listaItemsNew);
  }, [sortSel, filteredList])
  
  if (!list) {
    return <CLoading/>
  }
  
  
  const openPDF = async (ese) => {
    const result = await apiCliente.s3.get_read(ese.uid);
    
    if (!result.success) {
      LibToast.alert("Error al solicitar link del PDF " + result.message);
      return;
    }
    
    window.open(result.data.urlVer);
  }
  
  
  const trList = filteredList.map((r, index) => {
    
    /*

{"uid":xxx,
"id_ese_estatus":1,
"evaluado":"Ricardo Islas ",
"puesto":"Auxiliar","email":"vespsa.javier.vilchis@gmail.com",
"tel":"5541875418",
"nombreTipoEse":"buro de credito",
"id_version_ese":40,

"fsol":"20/09/2023","fupdate":"20/09/2023",
"isPDF":false,
"isSolCliente":false,"id_usuario_cliente_solicitado":null}


    * */
    return isMobile
      ? getTrMobile(r, index, openPDF)
      : getTrDesktop(r, index, openPDF)
  })
  
  
  const listItemsHead = isMobile
    ? ['Evaluado', "Estatus"]
    : [
      "#",
      'Evaluado',
      "Datos",
      "Puesto",
      "F. Solicitud",
      "PDF",
      ""
    ]
  
  const listaItemsMeta = [
    {label: '#', style: {width: "40px", textAlign: "center"}},
    {label: 'PDF', style: {width: "130px", textAlign: "center"}},
  ]
  
  const tHead = (
    <Thead
      sortSel={sortSel}
      setSortSel={setSortSel} listaLabel={listItemsHead} listaItemsMeta={listaItemsMeta}
    />
  );
  
  const listaInclude = ["uid", "evaluado"];
  
  const listItemCmd = [
    FacItemCmdTable.CopyXls(filteredList, listaInclude),
    FacItemCmdTable.PDFBasico(filteredList, list.length, listaInclude, 'Estudios')
  ];
  
  
  return (
    <>
      <TTable
        listItemCmd={listItemCmd}
        filtro={<FiltroEse filtro={filtro} setFiltro={setFiltro}/>}
        tHead={tHead}
        listaTR={trList}
      />
    
    
    </>
  );
};

export default EseTable